<div class="impact-matrix-container" *ngIf="!isLoadingLabels && !isLoadingMatrix">
	<span class="tip">{{ labels.lbl_adicao_impacto_urgencia_severidade_relacionamento }}</span>
	<span class="tip">{{ labels.lbl_clique_entre_linhas_colunas_adicionar_nova }}</span>
	<div
		class="impact-matrix"
		[ngStyle]="{
			'grid-template-columns': '1.75rem repeat(' + (impactMatrixHeader.length + 1) + ', 1fr)',
			'grid-template-rows': 'repeat(' + (urgencyMatrixHeader.length + 2) + ', 1.75rem)',
		}">
		<span class="empty-corner"></span>
		<span class="matrix-label" [ngStyle]="{ 'grid-column': 'span ' + impactMatrixHeader.length }">{{ labels.lbl_geral_impacto }}</span>
		<div class="impact" *ngFor="let impact of impactMatrixHeader; let index = index">
			<div
				[ngStyle]="{ height: (urgencyMatrixHeader.length + 1) * 1.75 + 'rem' }"
				class="add-column"
				(click)="addImpact(index)"></div>
			<div class="impact">
				<input [value]="impact.name" (input)="impact.name = $event.target.value" />
				<span class="remove-button" (click)="removeImpact(index)" *ngIf="this.impactMatrixHeader.length > 1"
					><fa-icon [icon]="icons.faTimes"></fa-icon
				></span>
			</div>
			<div
				[ngStyle]="{ height: (urgencyMatrixHeader.length + 1) * 1.75 + 'rem' }"
				class="add-column right"
				(click)="addImpact(index + 1)"
				*ngIf="index == impactMatrixHeader.length - 1"></div>
		</div>
		<span
			class="matrix-label vertical-cell left"
			[ngStyle]="{ 'grid-row': urgencyMatrixHeader.length <= 3 ? 'span 3' : 'span ' + urgencyMatrixHeader.length }"
			>{{ labels.lbl_geral_urgencia }}</span
		>
		<ng-container *ngFor="let urgency of urgencyMatrixHeader; let index = index">
			<div class="urgency">
				<div class="add-row" [ngStyle]="{ width: 100 * (impactMatrixHeader.length + 1) + '%' }" (click)="addUrgency(index)"></div>
				<div>
					<input [value]="urgency.name" (input)="urgency.name = $event.target.value" />
					<span class="remove-button" (click)="removeUrgency(index)" *ngIf="this.urgencyMatrixHeader.length > 1"
						><fa-icon [icon]="icons.faTimes"></fa-icon
					></span>
				</div>
				<div
					class="add-row bottom"
					[ngStyle]="{ width: 100 * (impactMatrixHeader.length + 1) + '%' }"
					(click)="addUrgency(index + 1)"
					*ngIf="index == urgencyMatrixHeader.length - 1"></div>
			</div>
			<span *ngFor="let severity of priorityMatrix[index]; let jindex = index">
				<input
					type="number"
					min="0"
					step="1"
					[value]="priorityMatrix[index][jindex].value"
					(input)="priorityMatrix[index][jindex].value = $event.target.value" />
			</span>
		</ng-container>
		<!-- <span class="add-button" [ngStyle]="{'grid-column': 'span '+ (impactMatrixHeader.length+2)}" (click)="addUrgency()">{{labels.lbl_nova_linha}}</span> -->
	</div>

	<div class="button-container">
		<div class="button" [ngClass]="{ disabled: isUpdatingMatrix }" (click)="updateImpactMatrix()">
			{{ labels.lbl_geral_atualizar }}
			<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdatingMatrix"></cpi-dot-bounce-loading-effect>
		</div>
	</div>
</div>

<cpi-dot-bounce-loading-effect
	[color]="'var(--primary-color-1)'"
	*ngIf="isLoadingLabels || isLoadingMatrix"></cpi-dot-bounce-loading-effect>
